import React, { Component } from 'react';
import fetchAllOutlets from '../data/outletsAPI';
import { Outlet } from '../components/outlet';
import Loading from '../components/loading';
import Search from '../components/search';

export class OutletsList extends Component {
  state = {
    loading: true,
    data: [],
    searchTerm: '',
    dataToDisplay: []
  };

  async componentDidMount() {
    this.searchChanged = this.searchChanged.bind(this);

    await fetchAllOutlets().then(response =>
      this.setState({ loading: false, data: response, dataToDisplay: response })
    );
  }

  generateListOfOutlets() {
    const outletList = [];
    const { dataToDisplay } = this.state;

    dataToDisplay.forEach(outlet => {
      outletList.push(<Outlet key={outlet.businessID} {...outlet} />);
    });

    return outletList;
  }

  searchChanged(e) {
    e.preventDefault();
    const { data } = this.state;

    const val = e.target.value;

    if (val === null || val.length === 0) {
      this.setState({ searchTerm: val, dataToDisplay: data });
    } else {
      const outletList = data.filter((value, index) => {
        const valInName = data[index].name
          .toUpperCase()
          .includes(val.toUpperCase());

        const tagsWithVal = data[index].tags.filter((jvalue, jindex) => {
          return data[index].tags[jindex]
            .toUpperCase()
            .includes(val.toUpperCase());
        });

        return valInName || tagsWithVal.length;
      });
      this.setState({ searchTerm: val, dataToDisplay: outletList });
    }
  }

  render() {
    const { loading, searchTerm } = this.state;
    const listOfOutlets = this.generateListOfOutlets();
    if (loading) {
      return <Loading />;
    }

    return (
      <div
        style={{
          backgroundColor: '#e6e6e6',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              margin: '20px 15px 0px',
              width: '70vw',
              maxWidth: '600px'
            }}
          >
            <div
              style={{
                padding: 15,
                backgroundColor: '#f7f7f7'
              }}
            >
              <Search
                searchChanged={e => this.searchChanged(e)}
                searchTerm={searchTerm}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 15
          }}
        >
          {listOfOutlets}
        </div>
      </div>
    );
  }
}

export default OutletsList;
